import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { requestCoachNote } from './api';
import type { CoachLocale } from './types';
import { reviewKey } from './useSessionReview';

/** Asks the server to have the AI coach word the review; the result replaces the cached review. */
export function useCoachNote(attemptId: string) {
  const { state } = useAuthContext();
  const queryClient = useQueryClient();
  const userId = state.user?.id;

  return useMutation({
    mutationFn: (locale: CoachLocale) => requestCoachNote(attemptId, locale),
    onSuccess: (review) => {
      // Keyed by the attempt the answer is about, not the one this hook currently has, so an
      // answer that lands after the page moved on cannot overwrite another attempt's review.
      if (review) queryClient.setQueryData(reviewKey(userId, review.attemptId), review);
    },
  });
}
